<template>
  <!-- top3 -->
  <q-section v-bind="$attrs">
    <q-section v-for="(item, index) in props.top3" :bg-i="item.bg" v-bind="genConfig(index)">
      <q-section :bg-i="item.avatar_url" v-bind="item.avatarPosition" @click="handleAvatarClick(item.user.user_id)"></q-section>
      <q-section
        v-if="item.buff_duration"
        :bg-i="item.buffBg"
        v-bind="item.buffPosition"
        class="flex flex-col items-start justify-center">
        {{ item.buff_ratio + '倍加速中' + item.buff_duration + '分钟' }}
      </q-section>
      <q-section v-bind="item.nicknamePosition" class="text-center ellipsis">
        {{ item.user?.nickname }}
      </q-section>
      <q-section v-bind="item.scorePosition" class="text-center text-nowrap">
        {{ item[item.scoreType] }}
      </q-section>
      <q-section v-bind="item.unitPosition" class="text-center text-nowrap">
        {{ item.unit }}
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
const props = defineProps<{
  top3: any[]
}>()

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}

const genConfig = (index: number) => {
  const map = {
    0: { pc: 'x', pt: '0' },
    1: { pl: '0', pb: '0' },
    2: { pr: '0', pb: '0' },
  } as const
  return map[index as keyof typeof map]
}
</script>

<style scoped lang="scss">
.ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
